<template>
    <app-page-content>
        <app-title>Circulares</app-title>
        <v-expansion-panel>
            <v-expansion-panel-content>
                <div slot="header">
                    Filtros
                </div>
                <v-card>
                    <v-card-title class="headline">Filtros</v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-menu
                                        :close-on-content-click="false"
                                        v-model="menu"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                    >
                                        <v-text-field
                                            slot="activator"
                                            v-model="filters.date"
                                            label="Fecha Circular"
                                            prepend-icon="event"
                                            readonly
                                        ></v-text-field>
                                        <v-date-picker v-model="filters.date" @input="menu = false"></v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex xs6>
                                    <v-btn small color="primary" @click="searchBroadcastMessages">Filtrar</v-btn>
                                </v-flex>
                                <v-flex xs6>
                                    <v-btn small flat  @click="cancelFilter">Restablecer</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>
        <div v-if="!!messages.length">
            <v-list two-lines>
                <template v-for="(message, index) in messages">
                    <v-list-tile :key="message.id" class="message-item">
                        <v-list-tile-avatar>
                            <img src="../../assets/file.png" alt="">
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-sub-title><strong>Asunto: </strong> {{message.name}}</v-list-tile-sub-title>
                            <v-list-tile-sub-title><strong>Fecha: </strong> {{message.created_at | datetime}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-content>
                            <v-btn slot="activator" @click="drillDown(message)" flat icon color="primary"><v-icon>zoom_in</v-icon></v-btn>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider
                        :key="index"
                    ></v-divider>
                </template>
            </v-list>
            <div class="text-xs-center">
                <v-pagination
                    v-if="!!messages"
                    v-model="page"
                    :length="totalPages"
                ></v-pagination>
            </div>
        </div>
        <v-alert v-else
            :value="!mails"
            type="info"
            >
            !Aún no has recibido ninguna circular!
        </v-alert>
        <v-layout row justify-center v-if="selectedMessage">
                <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                    <v-card>
                        <v-toolbar dark color="primary">
                        <v-btn icon dark @click="drillUp">
                            <v-icon>arrow_back</v-icon>
                        </v-btn>
                        <v-toolbar-title>Información Circular</v-toolbar-title>
                        </v-toolbar>
                        <v-list three-line subheader>
                        <v-subheader>Información</v-subheader>
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-sub-title><strong>Asunto:</strong> {{ selectedMessage.name }}</v-list-tile-sub-title>
                                <v-list-tile-sub-title><strong>Recibida el:</strong> {{ selectedMessage.created_at | datetime }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        </v-list>
                        <v-divider></v-divider>
                        <div class="message-container">
                            <div class="message-content" v-html="selectedMessage.description"></div>
                        </div>
                        <v-divider></v-divider>
                        <v-list three-line subheader v-if="selectedMessage.client_broadcast_message_files.length">
                            <v-subheader>Archivos</v-subheader>
                                <v-list-tile v-for="file in selectedMessage.client_broadcast_message_files" :key="file.id">
                                    <v-list-tile-content>
                                        <v-btn :href="file.file_url" target="_blank">{{ file.name }}</v-btn>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-carousel>
                        </v-list>
                    </v-card>
                </v-dialog>
            </v-layout>
    </app-page-content>
</template>
<script>
import broadcastMessageRepository from '../../repositories/broadcastMessages.repository';
export default {
    name: 'broadcast_messages',
    data: () => ({
        filters: {
            date: ''
        },
        page: 1,
        data: null,
        dialog: false,
        selectedMessage: null
    }),
    watch: {
        page(val) {
            this.searchBroadcastMessages();
        }
    },
    computed: {
        totalPages() {
            if(!this.data) return 0;

            return Math.ceil(this.data.total / parseInt(this.data.per_page));
        },
        messages() {
            if(!this.data) return [];

            return this.data.data;
        }
    },
    methods: {
        async searchBroadcastMessages() {
            const bmr = {...broadcastMessageRepository};

            try {
                const {data} = await bmr.getBroadcastMessages(this.user.id, this.filters, this.page);
                this.data = data;
            } catch(err) {
                toastr.error(`Ocurrió un error al cargar las circulares [${err.message}]`);
            }
        },
        drillDown(message) {
            this.selectedMessage = message;
            this.dialog = true;
        },
        drillUp() {
            this.selectedMessage = null;
            this.dialog = false;
        }
    },
    created() {
        this.searchBroadcastMessages();
    }
}
</script>
<style>
.message-item {
    margin: 10px 0;
}

.message-container {
    padding: 10px;
}
.message-content {
    border: 1px solid lightgray;
    border-radius: 10px;
    padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/BroadcastMessages/BroadcastMessages.vue